import {createQueryKeys} from "../../shared/query/query-keys";

const queryKeys = createQueryKeys("offerTemplates");
export const offerTemplateKeys = {
  ...queryKeys,
  bindingDefinitions: () => [...queryKeys.all, "binding-definitions"] as const,
  detail: (id: string) => queryKeys.detail(id.toLowerCase()),
};
export const offerTemplateMutationKeys = {
  createOfferTemplate: ["offerTemplates", "mutation", "create-offer-template"] as const,
  updateOfferTemplate: ["offerTemplates", "mutation", "update-offer-template"] as const,
  deleteOfferTemplate: ["offerTemplates", "mutation", "delete-offer-template"] as const,
  restoreOfferTemplate: ["offerTemplates", "mutation", "restore-offer-template"] as const,
  addOfferTemplateNote: ["offerTemplates", "mutation", "add-offer-template-note"] as const,
  editOfferTemplateNote: ["offerTemplates", "mutation", "edit-offer-template-note"] as const,
  removeOfferTemplateNote: ["offerTemplates", "mutation", "remove-offer-template-note"] as const,
} as const;
